<template>
	<div id="wrapper">
		<SidebarView :aiUpload="true"/>
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="mx-3">
					<!-- begin row  -->
					<div class="row">
						<div class="col-lg-12">
							<div class="card card-shape home-box">
								<div class="card-header">
									<div class="d-flex justify-content-between align-items-center">
										<div>
											<h6 class="m-0 fw-bold text-green">AI FAQ / Upload Knowledge File</h6>
										</div>
									</div>
								</div>
								<div class="card-body default_bg" style="border-bottom: 1px solid rgb(1, 134, 115);">
									<div class="home-box border border-success py-1 bg-white">
										<div class="card-body">
											
                      <form @submit.prevent="uploadFile()">
												<div class="row">
													<div class="col-12 col-md-6">
														<label class="akkurate-dark small d-none d-lg-block" for="search_term">File Title</label>
														<b-form-group id="search_term" label-for="search_term">
															<b-form-input class="mt-2 field-container fields" type="text" v-model="title" placeholder="Enter File name">
															</b-form-input>
														</b-form-group>
													</div>

													<div class="col mb-4 mb-md-0">
														<label class="akkurate-dark small d-none d-lg-block" for="type">Select Document</label>
														<b-form-group id="search_term" label-for="search_term">
															<b-form-file class="mt-2 field-container fields" @change="handleFile" type="file" v-model="file">
															</b-form-file>
														</b-form-group>
													</div>

													<div class="d-grid gap-2 col-md-2 d-flex align-content-center justify-content-center mt-auto ">
														<b-button :disabled="loading || !file || !title" type="submit" class="akkurate-green-btn akkurate-auth-size w-100 d-flex align-items-center justify-content-center"><i class="fas fa-plus "></i><span class="d-none d-lg-block ms-2">Upload</span></b-button>
													</div>
												</div>
                        <p
                          v-if="message"
                          :class="['message', error ? 'error' : 'success']"
                        >
                          {{ message }}
                        </p>
											</form>
										</div>
									</div>
								</div>
								<div class="card-body px-0 pt-0">
									<div class="table_text_size">
										<b-table striped bordered responsive id="member-table" :busy.sync="isBusy" :items="documents" :fields="fields" :tbody-tr-class="rowClass" show-empty>

											<template #table-busy>
												<div class="text-center text-danger my-2">
													<b-spinner class="align-middle"></b-spinner>
													<strong>Loading...</strong>
												</div>
											</template>
											<template #empty="scope">
												<h4 class="text-center small mt-3">{{ scope.emptyText }}</h4>
											</template>

											<template #cell(index)="data">
												{{ data.index + 1 }}
											</template>

											<template #cell(title)="data">
                        	{{ data.item?.title }}
											</template>

											<template #cell(number_of_chunks)="data">
													{{ data.item?.chunks_count }}
											</template>

											<template #cell(type)="data">
                        <span :class="statusBadge(data.item)">
                          {{ data.item?.type}}
                        </span>
											</template>

											<template #cell(actions)="data">
												<span class="d-flex">
													<a title="View Document" class="btn btn-sm akkurate-warning text-white broder-0 custom-pointer" @click="showDocumentViewModal(data.item.id)">
														<span class="akkurate-small"> <font-awesome-icon :icon="['fas', 'eye']" /></span>
													</a>
													<a title="Delete Document" class="btn btn-sm akkurate-danger-btn text-white border-0 custom-pointer" @click="deleteDocument(data.item)" variant="primary">
														<span class="akkurate-small"> <i class="fas fa-trash"></i></span>
													</a>

													<!-- <a title="Re-index Document" class="btn btn-sm akkurate-green-btn text-white border-0 custom-pointer" @click="approveEdit(data.item)">
														<span class="akkurate-small"><font-awesome-icon :icon="['fas', 'check']" /></span>
													</a> -->
												</span>
											</template>
										</b-table>

										<!-- <div class="d-flex justify-content-between px-3 pb-3">
											<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage" :total-rows="totalRecords" :per-page="perPage" aria-controls="member-table"></b-pagination>
											<div class="col text-end mt-1 akkurate-dark">
												<div>
													{{ currentPage }} -
													{{ perPage }} of
													{{ totalRecords }}
												</div>
												<b-form-group label="Per Page" label-size="sm" class="mb-0">
													<b-form-select @change="selectPerPage" id="per-page-select" v-model="perPage" :options="per_page_options
														" size="sm"></b-form-select>
												</b-form-group>
											</div>
										</div> -->
									</div>
								</div>
							</div>
						</div>
					</div>

					<b-modal size="xxl" id="bv-modal-document-view" hide-footer>
						<template #modal-title>
							<h6 class="m-0 fw-bold text-green text-sm">Document View</h6>
						</template>
						<AIViewDocument :id="document_id"></AIViewDocument>
					</b-modal>

				</div>
			</div>
			<footer></footer>
		</div>
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>

</template>

<script>
// import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import { uploadDocument,getDocuments,deleteDocumentById } from "@/core/services/ai.service";
import 'vue-good-table/dist/vue-good-table.css';
import AIViewDocument from "./Admin/AIViewDocument.vue";

export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
    AIViewDocument,
	},
	computed: {
	},

	data() {
    return {
      loading: false,
      document_id: null,
      title: '',
      file: null,
      message: '',
      error: false,
			isBusy: true,
      currentPage: 1,
			perPage: 10,
			per_page_options: ['10', '20', '50', '100', '500', '1000', '5000', '10000'],
			per_page_selected: "10",

			fields: [
				{
					label: '#',
					key: 'index',
				},
				{
					label: 'Document Title',
					key: 'title',
				},
				{
					label: 'Number of Chunks',
					key: 'number_of_chunks',
				},
				{
					label: 'Type',
					key: 'type',
				},
				{
					label: 'Actions',
					key: 'actions',
				},
      ],
      
			documents: [],
		};
	},
	mounted() {
		let token = localStorage.getItem('token');
		if (!token) {
			this.$router.push({ path: '/login' });
    }
    
		this.loadDocuments();
	},
  methods: {
		statusBadge(doc) {
			// console.log(item.status === 'Active');
			// if (item.get_pending_request_member_edit.length > 0) {
			// 	return 'badge akkurate-custom-mid-green'
			// }
			if (doc?.type === 'services') {
				return 'badge akkurate-green-bg'
			} else if (doc?.type === 'company') {
				return 'badge akkurate-green-bg'
			} else if (doc?.type === 'policy' || doc?.type === 'general') {
				return 'badge akkurate-danger-bg'
			} else {
				return 'badge akkurate-warning-bg'
			}
		},
		rowClass(item, type) {
				return 'custom-row-height'
		},

		navigatePage(index) {
			this.isBusy = true;
			this.currentPage = index;
			this.loadDocuments()
		},
		selectPerPage(index) {
			this.perPage = index
			this.loadDocuments()
    },

    async uploadFile() {
      if (!this.file || !this.title) {
        this.message = "Please provide both file and title.";
        this.error = true;
        return;
      }

      this.loading = true;

      this.isBusy = true;
      this.$Progress.start();

      await uploadDocument(
          this.title,
          this.file
        )
        .then(response => {
          this.message = "File uploaded successfully.";
          this.error = false;
          swal.fire({
								// title: response.statusText,
								text: response.data.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
          });
              
          this.loadDocuments();
        })
        .catch(error => {
          this.message = "Failed to upload file.";
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
          this.isBusy = false;
          this.$Progress.finish();
        });
    },
    
		showDocumentViewModal(id) {
      this.document_id = id;
      
			this.$bvModal.show('bv-modal-document-view')
    },
    
		// load items is what brings back the rows from server
		async loadDocuments() {
			this.isBusy = true;
			this.$Progress.start();  // Start the progress bar
			// console.log(this.form.users);
			await await getDocuments().then(response => {
        this.documents = response.data; 
        console.log(response.data);
				}).catch(() => {
					this.isBusy = false;  // Set isBusy to false in case of an error
					this.$Progress.finish();  // Finish the progress bar even if there's an error
					return [];  // Return an empty array in case of error to prevent the table from breaking
				}).finally(() => {
					this.isBusy = false;  // Set isBusy to false in case of an error
					this.$Progress.finish();  // Finish the progress bar even if there's an error
				});
		},

		deleteDocument(data) {
			swal.fire({
				title: "Please confirm",
				html: `Are you sure you want to <strong>DELETE</strong> Document <strong>${data.title}</strong>?<br/>This action cannot be reversed`,
				icon: "warning",
				allowOutsideClick: true,
				allowEscapeKey: true,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: "Delete", // Customize the text for the "OK" button
				cancelButtonText: "No", // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-red-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.$Progress.start();
					await deleteDocumentById(data.id)
						.then((response) => {
							// console.log(response);
							this.$Progress.finish();
							swal.fire({
								// title: response.statusText,
								text: response.data.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.loadDocuments();
						})
						.catch((error) => {
							this.$Progress.fail();
							// console.log(error);
							swal.fire({
								// title: response.statusText,
								text: error.response.data.message,
								icon: "error",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
						});
					//
				}
			});
    },

    handleFile (event) {
      this.file = event.target.files[0] || null;
    }
	},

};
</script>
